import axios from "axios";

export const baseURL =
  process.env.REACT_APP_API_URL ||
  "https://api.sinaisvitais.prosperasaude.com.br";

export const api = axios.create({
  baseURL: baseURL,
});
